// Generation Configuration Constants
export const GENERATION_CONFIG = {
  MAX_IMAGES: 100,
  REGENERATE_COST: 28, // Updated to match image generation price
  CREDITS_PER_PHOTO: 28, // Updated to match image generation price (was 3)
  DEFAULT_DATASET_SIZE: 10,
  MAX_DATASET_SIZE: 5,
} as const;

// Generation statuses
export const GENERATION_STATUS = {
  IDLE: 'idle',
  CREATING_MODEL: 'creating_model',
  GENERATING_IMAGES: 'generating_images',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

export type GenerationStatusType = (typeof GENERATION_STATUS)[keyof typeof GENERATION_STATUS];
